import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { NmLoadingOverlay } from '../../components/NmLoadingOverlay';
import logoUrl from '@assets/logo.png';

export function SplashPage() {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    if (auth.isLoading) return;
    navigate(auth.isAuthenticated ? '/calendar' : '/login', { replace: true });
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--surface-0)',
        gap: 16,
      }}
    >
      <img src={logoUrl} alt="VO2Peaks" width={104} height={30} style={{objectFit: 'contain', background: '#e8ecf2', padding: 6, borderRadius: 6}} />
      <NmLoadingOverlay />
    </div>
  );
}
